// eslint-disable-next-line no-unused-vars
import styled, { css } from 'styled-components/macro';
import { StyledFakeLabel } from '../../atoms/FakeLabel/FakeLabel.styles';

export const FieldHolder = styled.div`
  padding: 0 0 5px;

  /* .addressField {
    @media (min-width: 992px) {
      grid-column: span 3;
    }
  } */

  @media (min-width: 768px) {
    padding: 0 0 20px;
  }
`;

export const MapSection = styled.div`
  position: relative;

  @media (min-width: 992px) {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
`;

export const InputFlie = styled.div`
  position: relative;
`;

export const UploadMenu = styled.div`
  width: 100%;

  @media (min-width: 992px) {
    width: 50%;
  }
`;
export const ImgCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 20px;
  width: 100%;
  height: 200px;
  background: var(--white);
  border: 2px solid var(--light-secondary);
  border-radius: 12px;
  margin: 0 auto 20px;
  overflow: hidden;
  position: relative;
  padding-top: 10px;

  @media (min-width: 992px) {
    width: 100%;
    height: 250px;
    margin: 0 0 20px;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
  label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    color: rgba(74, 85, 104, 1);
    background: rgba(239, 242, 248, 1);
    padding: 10px;
    border-radius: 50px;
    font-size: 12px;
  }
  .uploadFile {
    display: none;
  }
`;

export const Holder = styled.div`
  width: 100%;
  margin: 0 0 10px;
  border-radius: 12px;

  @media (min-width: 992px) {
    width: 50%;
    margin: 0 0 30px;
  }

  /* @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
  } */

  ${({ $type }) =>
    $type &&
    $type === 'online' &&
    css`
      border: 2px solid var(--light);
      border-radius: 8px;
      max-width: 500px;
    `}
`;

export const MapColumn = styled.div`
  width: 100%;
`;
export const MapHolder = styled.div`
  width: 100%;
  height: 180px;
  position: relative;
  margin: 0 0 20px;

  @media (min-width: 768px) {
    height: 200px;
  }
  @media (min-width: 992px) {
    height: 250px;
  }

  > div {
    width: 100%;
    height: 100%;
  }
`;

export const ImgColumn = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 49%;
  }
  ${({ $type }) =>
    $type &&
    $type === 'online' &&
    css`
      width: 100% !important;
    `}
`;

export const ImgBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  height: 200px;
  flex-shrink: 0;
  background: var(--white);
  border: 2px solid var(--light-secondary);
  border-radius: 5px;
  margin: 0 0 20px;
  overflow: hidden;
  position: relative;
  padding-top: 10px;

  @media (min-width: 768px) {
    height: 250px;
  }

  img {
    display: block;
    width: 100%;
    border: 0;
    outline: none;
    object-fit: contain;
    height: auto;
  }
`;

export const RadioWrap = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: 992px) {
    flex-direction: column;
  }

  ${StyledFakeLabel} {
    font-size: 12px !important;
    line-height: 20px;
  }

  > div {
    padding: 0 10px;
  }
`;

export const BtnHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 767px) {
    justify-content: center;

    button {
      min-width: 125px;
    }
  }
`;

export const FileBtnHolder = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  background: var(--white);
  border: 2px solid var(--light-secondary);
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;
export const RadioHolder = styled.div``;

export const ImgHolder = styled.div`
  border-radius: 10px;
  width: 300px;
  height: 168px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (min-width: 992px) {
    width: 350px;
    height: 250px;
    border: 2px solid #eee;
  }
`;
